import React from 'react';
import Layout from './container/Layout/Layout'
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import Routes from './services/Routes'
import ProtectedRoutes from './components/protectedRoutes/ProtectedRoutes';
import * as authActionCreators from './store/Actions/Authentication-creator'
import Login from './container/Auth-page/Auth'
import UpdatePassword from "./components/Header-component/UpdatePassword/Auth";
import ForgotPassword from './components/Header-component/ForgetPassword/Auth';
import './App.css';
import PopupAlert from './components/Popup-alert/Popup-alert';
import { useHistory } from 'react-router-dom'

function App(props: any) {
  const { checkAuthStatus } = props;
  const history: any = useHistory();

  React.useLayoutEffect(() => {
    checkAuthStatus()
    // eslint-disable-next-line
  }, [])

  // var myRoutes = Routes.map((items : any)=>{
  //   var cloneItem = items
  //   if(items.path === "/dashboard"){
  //     cloneItem.status = 1
  //   }
  //   else{
  //     cloneItem.status = 0
  //   }
  //   return cloneItem
  // })

  return (
    <div className="App">
      <div className="alert_messages">
        <PopupAlert />
      </div>
      <React.Suspense fallback={<div className="route_loading" />}>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/forgotPassword" component={ForgotPassword} />
          <Route path="/forgot-password/change-password" component={UpdatePassword} />
          <Layout>
            {
              Routes.map((route: any, i: any) => (
                <ProtectedRoutes
                  path={route?.path}
                  exact={route?.exact !== false}
                  status={0}
                  Component={route.Component}
                  routes={route.routes}
                  key={i} />
              ))
            }
          </Layout>
        </Switch>
      </React.Suspense>
    </div>
  );
}

const mapStateToProps = (state: any) => {
  return {
    authData: state.authState,
    searchData: state.searchState
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    checkAuthStatus: () => dispatch(authActionCreators.initAuthStatus())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
